import { render, staticRenderFns } from "./ResourcePoolOptionList.vue?vue&type=template&id=61db28f5&scoped=true&"
import script from "./ResourcePoolOptionList.vue?vue&type=script&lang=js&"
export * from "./ResourcePoolOptionList.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePoolOptionList.vue?vue&type=style&index=0&id=61db28f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db28f5",
  null
  
)

export default component.exports